module.exports = __webpack_public_path__ + "img/仓储费明细.9b0ba4fb.svg";